import type { CategoryItem } from '@/types/drama';

export const categories: CategoryItem[] = [
  { key: '都市', label: '都市', icon: 'ri-building-2-line' },
  { key: '古装', label: '古装', icon: 'ri-ancient-gate-line' },
  { key: '悬疑', label: '悬疑', icon: 'ri-question-line' },
  { key: '爱情', label: '爱情', icon: 'ri-heart-3-line' },
  { key: '科幻', label: '科幻', icon: 'ri-rocket-2-line' },
  { key: '家庭', label: '家庭', icon: 'ri-home-heart-line' },
  { key: '动作', label: '动作', icon: 'ri-sword-line' },
  { key: '喜剧', label: '喜剧', icon: 'ri-emotion-happy-line' },
  { key: '历史', label: '历史', icon: 'ri-book-2-line' },
];

export const regions: string[] = ['中国大陆', '中国香港', '韩国', '日本', '美国'];

export const years: number[] = [2025, 2024, 2023];